import { useEffect } from 'react';
import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { getBackofficeLoginRequest } from './config';

export function LoginPage() {
  const { instance, inProgress } = useMsal();

  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      void instance.loginRedirect(getBackofficeLoginRequest());
    }
  }, [inProgress, instance]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-white text-small text-neutral-600">
      Signing in...
    </div>
  );
}
